import React, { memo } from "react";
import PropTypes from "prop-types";

function Button({
  label,
  type = "submit",
  status = "theme",
  disabled = false,
  onClick,
  icon,
  className = "",
  isLoading = false,
  unreadCount = 0,
}) {

  return (
    <>
      <button
        type={type}
        title={label}
        className={`btn button-${status}  ${className}`}
        disabled={disabled}
        onClick={onClick}
      >
        {icon && <i className={`fa fa-${icon} me-2`}></i>}
        {label}
        {unreadCount != 0 && (
          <>
            <div className="badge"style={{backgroundColor: '#1f2f46'}}>{unreadCount}</div>
          </>
        )}
        {isLoading && disabled && (
          <div className="spinner-border spinner-border-sm" role="status"></div>
        )}
      </button>

    </>
  );
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  status: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  className: PropTypes.string, // Allow passing additional classes
};

export default memo(Button);
